import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {ChecklisteLoeschenPage} from './checkliste-loeschen.page';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';

const routes: Routes = [
    {
        path: '',
        component: ChecklisteLoeschenPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        SopiScrollModule,
        SopiComponentsModule.forRoot()
    ],
    declarations: [ChecklisteLoeschenPage]
})
export class ChecklisteLoeschenPageModule {
    public static forRoot(): ModuleWithProviders<ChecklisteLoeschenPageModule> {
        return {
            ngModule: ChecklisteLoeschenPageModule,
        };
    }
}
